/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";
import { ErrorUtils } from "abweb/utils/ErrorUtils";

/**
 * Multi-cast event structure with strongly typed argument.
 * For a class to implement an event broadcaster.
 */
export class AsyncCallback1Arg extends CallbackHolder {
  async callInternal(x, callbacks) {
    const errors = [];
    for (const callback of callbacks) {
      try {
        await callback(x);
      } catch (e) {
        errors.push(e);
      }
    }
    if (errors.length > 0) {
      throw new Error("Some callbacks threw errors:\n" + errors.map(e => {
        // Note that Chrome and firefox handle this differently. Chrome prints the error
        // message as part of stack, so the error will appear twice. This is necessary because
        // Firefox doesn't print the error, so we need to do it manually.
        if (e["stack"]) {
          return ErrorUtils.getErrorMsgFromObj(e) + "\n" + String(e["stack"]);
        }
        return ErrorUtils.getErrorMsgFromObj(e);
      }).join("\n"));
    }
  }

  /**
   * Send a notification to all listeners.
   * Waits for a listener to finish before invoking the next listener.
   * Listeners will be invoked in order in which they were registered.
   */
  async callAll(x) {
    await this.callInternal(x, this.getCallbacks());
  }

  /**
   * Send a notification to all listeners, in reverse order from when they were registered.
   * Waits for a listener to finish before invoking the next listener.
   * Useful for invoking 'teardown' listeners in reverse registration order.
   */
  async callAllInReverseOrder(x) {
    // getCallbacks returns a copy, so reversing in place is OK.
    await this.callInternal(x, this.getCallbacks().reverse());
  }
}
//# sourceMappingURL=AsyncCallback1Arg.js.map
